module.exports = __webpack_public_path__ + "components/home-header/static/header-7--huge-6067378b0b3e4637b27722eec81550bf.jpg";